import { useApiShopsShopIdbrandsGetCollection } from '@r/api/generated/client.ts';
import type { ApiShopsShopIdbrandsGetCollectionParams } from '@r/api/generated/client.schemas.ts';

type UseShopBrandsParams = {
  shopId?: string;
  categoryIds?: string[];
  enabled?: boolean;
};

/**
 * Récupère les marques disponibles pour une boutique, optionnellement filtrées par catégorie.
 * Le back attend les IDs de catégories via `products.category[]`.
 * Les marques sont mises en cache 5 minutes pour limiter les appels réseau.
 */
export const useShopBrands = ({
  shopId,
  categoryIds = [],
  enabled = true
}: UseShopBrandsParams) => {
  const params: ApiShopsShopIdbrandsGetCollectionParams | undefined =
    categoryIds.length > 0 ? { 'products.category[]': categoryIds } : undefined;

  return useApiShopsShopIdbrandsGetCollection(shopId, params, {
    query: {
      queryKey: ['shop-brands', shopId, params],
      enabled: !!shopId && enabled,
      placeholderData: (previousData) => previousData,
      staleTime: 5 * 60 * 1000
    }
  });
};
